import React from 'react';
import Slider from 'react-slick';
import { FaGithub } from 'react-icons/fa';
import './ProjetosCarrossel.css';
import nutriImage from '../imagens/nutri.jpeg';
import RelogioImage from '../imagens/relogio.jpeg';
import ForcaImage from '../imagens/forca.jpeg';
import GatoImage from '../imagens/gato.jpeg';
import ListaImage from '../imagens/lista.jpeg';
import CoresImage from '../imagens/cores.jpeg';
import CalendarioImage from '../imagens/calendario.jpeg';
import PokeDexImage from '../imagens/pokedex.jpg';

const ProjetosCarrossel = () => {
  const projetos = [
   
    {
      titulo: "Relógio Digital",
      descricao: "Relógio que mostra as horas exatas no horário de Brasília, mudando de cor de acordo com o horário.",
      tecnologias: ["JavaScript", "HTML", "CSS"],
      imagem: RelogioImage,
      githubUrl: "https://github.com/Joao6632/RelogioDigital"
    },

     {
      titulo: "Site Nutrição",
      descricao: "Aplicação desktop cujo a motivação é para facilitar o nutricionista realizar o calculo nutricional do paciente dentro do seu ambiente de trabalho.",
      tecnologias: ["JavaScript", "HTML", "CSS"],
      imagem: nutriImage,
      githubUrl: "https://github.com/Joao6632/Site-nutri"
    },

    {
      titulo: "Jogo da Forca",
      descricao: "Um jogo da forca utilizando phyton, basta você colocar a palavra que deseja dentro do código e executar, a cada tentativa falha, o bonequinho irá ter uma nova parte do corpo",
      tecnologias: ["Phyton"],
      imagem: ForcaImage,
      githubUrl: "https://github.com/Joao6632/JogoDaForcaGrafico"
    },

    {
      titulo: "The association",
      descricao: "Um bot criado por mim para ser utilizado no discord, ainda em etapa inicial, possui alguns comandos de moderação e exibição de relatórios das punições.",
      tecnologias: ["Discord.py", "JavaScript"],
      imagem: GatoImage,
      githubUrl: "https://github.com/Joao6632/BotDisocrd"
    },

    {
      titulo: "To Do List",
      descricao: "Uma lista de afazeres basicamente, utilizando phyton como servidor local",
      tecnologias: ["Phyton", "JavaScript", "CSS", "HTML"],
      imagem: ListaImage,
      githubUrl: "https://github.com/Joao6632/ToDoList"
    },

    {
      titulo: "Gerador de cor aleatória",
      descricao: "Um mini programa cujo objetivo é fornecer cores aleatórias, basta apertar o botão de randomizar, irá fornecer o código dela e irá mudar o fundo de acordo com a cor.",
      tecnologias: ["JavaScript", "HTML", "CSS"],
      imagem: CoresImage,
      githubUrl: "https://github.com/Joao6632/GeradorDeCorAleatoria"
    },

    {
      titulo: "Calendário",
      descricao: "É um calendário.",
      tecnologias: ["JavaScript", "CSS", "HTML"],
      imagem: CalendarioImage,
      githubUrl: "https://github.com/Joao6632/Calendario"
    },

    {
      titulo: "Pokédex",
      descricao: "Pokédex, que serve para pesquisar sobre pokemons, mostrando a tipagem, número na pokédex e nome do pokémon, feito para testar o conhecimento de JS.",
      tecnologias: ["JavaScript", "CSS", "HTML"],
      imagem: PokeDexImage,
      githubUrl: "https://github.com/Joao6632/Pokedex"
    }
  
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1, // Mostra 1 por vez
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000
  };

  return (
    <div className="carrossel-simples">
      <Slider {...settings}>
        {projetos.map((projeto, index) => (
          <div key={index} className="projeto-item">
            <div className="projeto-imagem">
              <img src={projeto.imagem} alt={projeto.titulo} />
            </div>
            <div className="projeto-info">
              <h3>{projeto.titulo}</h3>
              <p>{projeto.descricao}</p>
              <div className="tecnologias">
                {projeto.tecnologias.map((tech, i) => (
                  <span key={i}>{tech}</span>
                ))}
              </div>
              <a href={projeto.githubUrl} className="botao-github">
                <FaGithub /> Ver código
              </a>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ProjetosCarrossel;